module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component reveal"
  }, [_c('div', {
    directives: [{
      name: "f-nd",
      rawName: "v-f-nd"
    }],
    staticClass: "reveal",
    attrs: {
      "id": _vm.id,
      "data-reveal": "data-reveal",
      "data-options": _vm.options
    }
  }, [_vm._m(0), _vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abd7a950!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/Reveal.vue
// module id = 2642
// module chunks = 1